/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Gear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Gear"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#63B8D2"
        d="M6.796 2.561c-.069.167-.069.379-.069.803 0 .423 0 .635.07.802.092.223.269.4.491.492.168.07.38.07.803.07h1.364V12L6.91 14.873C4.976 17.15 4.01 18.29 4 19.25a2.69 2.69 0 0 0 1.058 2.15c.777.6 2.304.6 5.358.6h3.531c3.055 0 4.582 0 5.359-.601a2.69 2.69 0 0 0 1.057-2.15c-.008-.96-.975-2.099-2.91-4.376L14.91 12V4.727h1.364c.423 0 .635 0 .802-.069a.9.9 0 0 0 .492-.492c.07-.167.07-.379.07-.802s0-.636-.07-.803a.9.9 0 0 0-.492-.492C16.908 2 16.696 2 16.273 2H8.09c-.424 0-.635 0-.803.07a.9.9 0 0 0-.492.491"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M9.455 4.727h1.818a.91.91 0 0 1 0 1.818H9.455zm0 2.728h1.818a.91.91 0 0 1 0 1.818H9.455zm0 2.727h1.818a.91.91 0 0 1 0 1.818H9.455z"
        className="Details"
      />
    </g>
  </svg>
);

export const GearIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'gear-icon'}
      icon={Gear}
      {...props}
      size={size}
    />
  );
};
